import Input from 'antd-core/es/input/Input';
import styled from 'styled-components';
import { width, height, margin, padding } from '@10d/tend-ui-styling';

const Root = styled(Input) `
  &.tend-ui-input {
    font-size: 14px;
    line-height: 24px;
    text-overflow: ellipsis;
  }
  &.tend-ui-input-affix-wrapper {
    > input.tend-ui-input {
      text-overflow: ellipsis;
      font-size: 14px;
      line-height: 24px;
    }
    .tend-ui-input-suffix {
      color: ${props => props.$theme.colors.gray400};
    }
    .tend-ui-input-prefix {
      margin-inline-end: 8px;
      color: ${props => props.$theme.colors.gray400};
    }
    .tend-ui-input-clear-icon {
      display: flex;
    }
    .anticon {
      font-size: 16px;
    }
  }

  &.tend-ui-input,
  &.tend-ui-input-affix-wrapper {
    ${width};
    ${height};
    ${margin};
    ${padding};
  }
`;

export { Root };
